import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Table } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { req_list_ssp_school_source_detail } from "../../api";

class SourceSchoolInfoModal extends Component {
  state = {
    userLevel: "",
    loading: false,
    isShowAddModal: false,
    item: {},
    obj: {},
    items: [],
  };

  static propTypes = {
    item: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_list_items();
    this.setState({ item: this.props.item });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { item } = this.props;
    const { PlanAcademicYear, HighSchoolCode } = item;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_list_ssp_school_source_detail(
      userCode,
      userLevel,
      PlanAcademicYear,
      HighSchoolCode,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items: items, loading: false });
    } else {
      const items = [];
      this.setState({ items: items, loading: false });
    }
  };
  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學程",
        dataIndex: "ProgramLevelName",
        width: 30,
        responsive: ["md"],
      },
      {
        title: "日夜別",
        dataIndex: "DayNightName",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "群別",
        dataIndex: "ClusterName",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "系所",
        dataIndex: "DepartmentName",
        width: 40,
      },
      {
        title: "即將畢業數",
        dataIndex: "WillGraduateStudentTotal",
        width: 40,
      },
    ];
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading, items } = this.state;
    const {
      HighSchoolCode,
      HighSchoolTwName,
      CountyCity,
      SchoolAddress,
      SchoolTelephone,
      SchoolUrl,
    } = this.props.item;
    return (
      <Card>
        <form>
          <div className="form-row">
            <div className="col-lg-4">
              <div className="form-group">
                <label>所在縣市</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  name="CountyCity"
                  id="CountyCity"
                  defaultValue={CountyCity}
                  readOnly={true}
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>學校代號</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  name="HighSchoolCode"
                  id="HighSchoolCode"
                  defaultValue={HighSchoolCode}
                  readOnly={true}
                />
                <div></div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>學校名稱</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  name="HighSchoolCode"
                  id="HighSchoolCode"
                  style={{ backgroundColor: "LightYellow" }}
                  defaultValue={HighSchoolTwName}
                  readOnly={true}
                />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-5">
              <div className="form-group">
                <label>地址：</label>
                <a
                  href={"https://www.google.com/maps?q=" + SchoolAddress}
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "underline" }}
                >
                  {SchoolAddress}
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>網址：</label>
                <a
                  href={SchoolUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "underline" }}
                >
                  {SchoolUrl}
                </a>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="form-group">
                <label>電話：</label>
                <a
                  href={"tel:" + SchoolTelephone}
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "underline" }}
                >
                  {SchoolTelephone}
                </a>
              </div>
            </div>
          </div>
        </form>
        <Table
          key={items[0]}
          dataSource={items}
          columns={this.columns}
          loading={loading}
          scroll={{ y: 460 }}
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SourceSchoolInfoModal);
